<template>
	<div v-if="(item.shipping_options && item.active_shipping_options_count) || item.warehouses_display" class="cd-item-info-container">
		<template v-if="item.shipping_options && item.active_shipping_options_count">
			<div class="cd-item-info cd-item-info-shipping" @click="flyoutShipping()">
				<div class="cd-item-info-title shipping"><BaseCmsLabel code="item_delivery_tab_title" /></div>
				<template v-for="(options, index) in item.shipping_options" :key="options.id">
					<div v-if="options.id != 'p'" class="cd-item-info-desc">
						<template v-if="item.status == 5">
							<span v-if="options.id == 's'" v-html="labels.get('item_delivery_standard_delivery')"></span>
							<span v-else-if="options.id == 'e'" v-html="labels.get('item_delivery_express_delivery')"></span>
							<span v-else-if="options.id == 'bb'" v-html="labels.get('item_delivery_bigbang_delivery')"></span>
							<span v-else-if="options.id == 'bb_xxl'" v-html="labels.get('item_delivery_bigbang_xxl_delivery')"></span>
							<span v-else-if="options.id == 'bb_fast' && options.fast_shipping" v-html="labels.get('item_delivery_premium_title')"></span>&nbsp;<span v-html="labels.get('item_time_of_delivery_preorder').replace('%s%', formatDate(item.shipping_date))"></span>
							<template v-if="options.shipping_price <= 0">
								- <strong class="green"><BaseCmsLabel code="free" /></strong>
							</template>
						</template>
						<template v-else-if="item.status != 5">
							<span v-if="options.id == 's'" v-html="labels.get('item_delivery_standard_delivery')"></span>
							<span v-else-if="options.id == 'e'" v-html="labels.get('item_delivery_express_delivery')"></span>
							<span v-else-if="options.id == 'bb'" v-html="labels.get('item_delivery_bigbang_delivery')"></span>
							<span v-else-if="options.id == 'bb_xxl'" v-html="labels.get('item_delivery_bigbang_xxl_delivery')"></span>
							<span v-else-if="options.id == 'bb_fast' && options.fast_shipping" v-html="labels.get('item_delivery_premium').replace('%s%', options.fast_shipping_titles?.join(','))"></span>
							<template v-if="options.id != 'bb_fast'">
								&nbsp;<span v-if="new Date(options.min_delivery_date * 1000).toDateString() === new Date().toDateString()" v-html="labels.get('item_time_of_delivery_today').replace('%s%', shippingDate[index])"></span>
								<span v-else-if="new Date(options.min_delivery_date * 1000).toDateString() === tomorrow.toDateString()" v-html="labels.get('item_time_of_delivery_tomorow').replace('%s%', shippingDate[index])"></span>
								<span v-else v-html="labels.get('item_time_of_delivery').replace('%s%', shippingDate[index])"></span>
							</template>
							<template v-if="options.shipping_price <= 0">
								- <strong class="green"><BaseCmsLabel code="free" /></strong>
							</template>
						</template>
					</div>
				</template>
			</div>
		</template>

		<div v-if="item.status != 7 && item.shipping_options?.some(obj => obj.id === 'p')" class="cd-item-info cd-item-info-stores" @click="flyoutStores()">
			<div class="cd-item-info-title stores">
				<span v-if="item.status == '4' && item.warehouses_display" v-html="labels.get('item_stores_tab_title_limited')"></span>
				<span v-else v-html="labels.get('item_stores_tab_title')"></span>
			</div>
			<div class="cd-item-info-desc">
				<template v-if="item.status == 5">
					<span v-if="item.warehouses_single_pickup_display?.title" v-html="labels.get('item_time_of_delivery_preorder_single').replace('%s%', item.warehouses_single_pickup_display.title).replace('%s2%', formatDate(item.shipping_date))"></span>
					<span v-else v-html="labels.get('item_time_of_delivery_preorder').replace('%s%', formatDate(item.shipping_date))"></span>
				</template>
				<template v-else-if="item.shipping_options?.some(obj => obj.id === 'p' && obj.active == true)">
					<span v-if="item.warehouses_single_pickup_display?.title" v-html="labels.get('item_delivery_pickup_single').replace('%s%', item.warehouses_single_pickup_display.title)"></span>
					<span v-else v-html="labels.get('item_delivery_pickup_store')"></span>&nbsp;<span v-if="new Date(date * 1000).toDateString() === new Date().toDateString()" v-html="labels.get('item_time_of_delivery_today').replace('%s%', pickupDate)"></span>
					<span v-else-if="new Date(date * 1000).toDateString() === tomorrow.toDateString()" v-html="labels.get('item_time_of_delivery_tomorow').replace('%s%', pickupDate)"></span>
					<span v-else v-html="labels.get('item_time_of_delivery').replace('%s%', pickupDate)"></span>
				</template>
			</div>
			<div v-if="((item.status == 1 && !item.warehouses_single_pickup_display) || (item.status == 4 && item.warehouses_display))" class="cd-item-info-desc link" v-html="labels.get('warehouses_availability')"></div>
		</div>
	</div>
</template>

<script setup>
	const labels = useLabels();
	const props = defineProps(['item']);
	const {formatDate} = useText();
	const {emit} = useEventBus();

	function flyoutShipping() {
		document.body.classList.add('flyout-page', 'cd-flyout-active');
		const content = {
			shipping_dates: shippingDate,
			date: props.item.shipping_date,
			status: props.item.status,
			shipping_options: props.item.shipping_options
		};

		emit('flyoutUpdate', {'flyout_mode': 'shipping', 'flyout_content': content ? content : null});
	}

	function flyoutStores() {
		document.body.classList.add('flyout-page', 'cd-flyout-active');

		let title = labels.get('item_stores_flyout_title');
		if(props.item.status == 4 && props.item.warehouses_display) {
			title = labels.get('item_stores_flyout_title')
		}

		const content = {
			status: props.item.status,
			warehouses_single_pickup_display: props.item.warehouses_single_pickup_display,
			last_piece_sale: props.item.last_piece_sale,
			warehouses_display: props.item.warehouses_display,
			is_available: props.item.is_available,
			shipping_options: props.item.shipping_options
		};

		emit('flyoutUpdate', {'flyout_mode': 'stores', 'flyout_title': title, 'flyout_content': content ? content : null});
	}

	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);
	const calendarMonth = ['januarja', 'februarja', 'marca', 'aprila', 'maja', 'junija', 'julija', 'avgusta', 'septembra', 'oktobra', 'novembra', 'decembra'];
	const calendarDays = ['nedelje', 'ponedeljka', 'torka', 'srede', 'četrtka', 'petka', 'sobote'];

	const shippingDate = computed(() => {
		return props.item.shipping_options?.map((item) => {
			const shippingDateDay = new Date(item.min_delivery_date * 1000).getDay();
			const shippingDateMonth = new Date(item.min_delivery_date * 1000).getMonth();

			if (calendarDays[shippingDateDay] && calendarMonth[shippingDateMonth]) {
				if (new Date(item.min_delivery_date * 1000).toDateString() === new Date().toDateString() || new Date(item.min_delivery_date * 1000).toDateString() === new Date(Date.now() + 86400000).toDateString()) {
					return new Date(item.min_delivery_date * 1000).getDate() + '.' + (new Date(item.min_delivery_date * 1000).getMonth() + 1) + '.';
				} else {
					return calendarDays[shippingDateDay] + ', ' + new Date(item.min_delivery_date * 1000).getDate() + '.' + (new Date(item.min_delivery_date * 1000).getMonth() + 1) + '.';
				}
			} else {
				return new Date(item.min_delivery_date * 1000).toLocaleString('en-US', {weekday: 'short', day: 'numeric', month: 'long'});
			}
		});
	});

	const date = (props.item.status == 5) ? props.item.shipping_date : props.item?.shipping_options?.find(option => option.id === 'p')?.min_delivery_date || null;
	const pickupDate = computed(() => {
		const pickupDateDay = new Date(date * 1000).getDay();
		const pickupDateMonth = new Date(date * 1000).getMonth();

		if (calendarDays[pickupDateDay] && calendarMonth[pickupDateMonth]) {
			if (new Date(date * 1000).toDateString() === new Date().toDateString() || new Date(date * 1000).toDateString() === new Date(Date.now() + 86400000).toDateString()) {
				return new Date(date * 1000).getDate() + '.' + (new Date(date * 1000).getMonth() + 1) + '.';
			} else {
				return calendarDays[pickupDateDay] + ', ' + new Date(date * 1000).getDate() + '.' + (new Date(date * 1000).getMonth() + 1) + '.';
			}
		} else {
			return new Date(date * 1000).toLocaleString('en-US', {weekday: 'short', day: 'numeric', month: 'long'});
		}
	});
</script>

<style lang="less" scoped>
	.cd-item-info-container{width: 100%; margin-top: 20px;}
	.cd-item-info{
		display: flex; flex-direction: column; justify-content: center; flex-grow: 1; margin: 0 0 -1px; padding: 20px 70px; border: 1px solid @borderColor; position: relative; cursor: pointer; .transition(border-color);
		&:before{.icon-arrow-down(); font: 12px/12px @fonti; font-weight: 600; color: @blue; position: absolute; right: 25px; .rotate(-90deg); .transition(right);}
		@media (min-width: @t){
			&:hover{border-color: @hoverBorderColor; z-index: 1;}
		}

		@media (max-width: @t){
			padding: 15px 60px;
			&:before{right: 20px;}
		}
		@media (max-width: @m){
			padding-right: 50px;
			&:before{font-weight: normal; right: 17px;}
		}
	}
	.cd-item-info-title{
		font-size: 15px; line-height: 1.4; font-weight: 600; position: relative;
		&.shipping:before{.icon-delivery(); font: 21px/21px @fonti; color: @blue; position: absolute; left: -44px; top: 8px;}
		&.stores:before{.icon-store2(); font: 25px/25px @fonti; color: @blue; position: absolute; left: -43px; top: 8px;}

		@media (max-width: @t){
			&.shipping:before{font-size: 18px; line-height: 18px; left: -41px;}
			&.stores:before{font-size: 22px; line-height: 22px; left: -40px;}
		}
		@media (max-width: @m){
			&.shipping:before{font-size: 19px; line-height: 19px; left: -40px; top: 2px;}
			&.stores:before{font-size: 23px; line-height: 23px; top: 5px;}
		}
	}
	.cd-item-info-desc{
		padding-top: 2px; font-size: 14px; line-height: 1.4;
		&.link{
			color: @blue; text-decoration: underline; font-weight: 600;
			&:hover{color: @blue; text-decoration: none;}
		}
		.shipping-price.free strong{color: @lightGreen;}

		@media (max-width: @t){
			&.link:hover{text-decoration: underline;}
		}
	}
</style>
